module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./NoviceCourseListView.js"));
	}, "NoviceCourseListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NoviceCourseListView!./src/pages/Shop/Member/Personal/NoviceCourse/NoviceCourseList/NoviceCourseListView.js
// module id = 998
// module chunks = 431